import React, { FC } from 'react';
import consts from '@/config/consts';
import styled from 'styled-components';

const Image = styled.img<{ $blockIcon: boolean; $isCarousel?: boolean }>`
  display: inline-block;
  //Prevent img stretching on Safari browser
  height: ${({ $isCarousel }) => $isCarousel && '100%'};
  width: ${({ $isCarousel }) => $isCarousel && 'auto'};

  td & {
    height: auto;

    &.inline-icon {
      height: 17px !important;
      width: auto !important;
    }

    padding-right: ${({ theme }) => theme.space.xs};

    &:not(:only-child) {
      max-width: 49%;

      &:first-of-type {
        padding-right: unset;
      }
    }
  }

  /* Block icons in tables - maintain consistent size */
  ${({ $blockIcon }) =>
    $blockIcon &&
    `
    width: 125px;
    height: 117px;
    td & {
      width: 125px !important;
      height: 117px	 !important;
      object-fit: contain;
      display: block;
      margin: 0;

    }
  `}

  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) and (stroke-color: transparent) {
      image-rendering: unset;
    }
  }
`;

type ImageProps = {
  imageId: string;
  node: Elvita.Topic;
  isCarousel?: boolean;
  children?: React.ReactNode;
};

const Img: FC<ImageProps> = ({ node, imageId, isCarousel }) => {
  const isInlineIcon = node.attribs['data-template'] === '106';

  return (
    <Image
      className={`${node.attribs.class} ${
        isInlineIcon ? 'inline-icon' : ''
      }`.trim()}
      width={node.attribs.width}
      src={`${consts.imagesCdnUrl}/images/${imageId}`}
      alt={node.attribs.alt ?? ''}
      $blockIcon={node.attribs['data-template'] === '68'}
      $isCarousel={isCarousel}
    />
  );
};

export default Img;
